import VoteArrowWithBadge from 'cc/VoteArrowWithBadge'

const VoteArrowOverview = ({ reviewCounts = {}, className }) => {
  return (
    <div className="w-full text-center">
      <div className={className}>
        <VoteArrowWithBadge vote={-1} text={reviewCounts[-1]} />
        {reviewCounts[0] ? <VoteArrowWithBadge vote={0} text={reviewCounts[0]} /> : null}
        <VoteArrowWithBadge vote={1} text={reviewCounts[1]} />
      </div>
    </div>
  )
}

export default VoteArrowOverview
